/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
var a = /* @__PURE__ */ ((e) => (e.remove = "remove", e.add = "add", e.reorder = "reorder", e))(a || {});
const o = (e, r) => {
  switch (r.type) {
    case "add":
      break;
    case "remove":
      return e.filter((d) => d[r.valueField] !== r.payload);
    case "reorder":
      break;
    default:
      return e;
  }
};
export {
  a as CHIP_DATA_ACTION,
  o as dataReducer
};
